class ColumnFormula {
    name = '';
    label = '';
    needsArgs = false;
    _args = {};
    _transform = (values) => values;
    _getLabel = null;

    constructor({name, label, args = {}, transform, _transform, getLabel, _getLabel}) {
        this.name = name;
        this.label = label;
        this._args = args;
        this.needsArgs = Object.keys(args).length > 0;
        this._transform = transform || _transform || this._transform;
        this._getLabel = getLabel || _getLabel || this._getLabel;
    }

    getLabel(...args) {
        return this._getLabel ? this._getLabel(...args) : this.label;
    }

    validate(args = {}) {
        for (const [arg, type] of Object.entries(this._args)) {
            const argValue = args[arg];
            if (typeof argValue !== type) {
                return false;
            }
        }
        return true;
    }

    apply(values, args = {}) {
        return this.validate(args) ? this._transform(values, args) : null;
    }
}

const ADD = new ColumnFormula({
    name: 'ADD',
    label: 'Add',
    args: {amount: 'number'},
    transform(values, {amount}) {
        return values.map(value => value + amount);
    },
    getLabel({column, amount}) {
        return `Add ${amount}${column ? ` to ${column}` : ''}`;
    },
});
const SUBTRACT = new ColumnFormula({
    name: 'SUBTRACT',
    label: 'Subtract',
    args: {amount: 'number'},
    transform(values, {amount}) {
        return values.map(value => value - amount);
    },
    getLabel({column, amount}) {
        return `Subtract ${amount}${column ? ` from ${column}` : ''}`;
    },
});
const MULTIPLY = new ColumnFormula({
    name: 'MULTIPLY',
    label: 'Multiply',
    args: {amount: 'number'},
    transform(values, {amount}) {
        return values.map(value => value * amount);
    },
    getLabel({column, amount}) {
        return `Multiply${column ? ` ${column}` : ''} by ${amount}`;
    },
});
const DIVIDE = new ColumnFormula({
    name: 'DIVIDE',
    label: 'Divide',
    args: {amount: 'number'},
    transform(values, {amount}) {
        return values.map(value => value / amount);
    },
    getLabel({column, amount}) {
        return `Divide${column ? ` ${column}` : ''} by ${amount}`;
    },
});
const RUNNING_TOTAL = new ColumnFormula({
    name: 'RUNNING_TOTAL',
    label: 'Running Total',
    transform(values) {
        let sum = 0;
        return values.map((value) => {
            sum += value;
            return sum;
        });
    },
    getLabel({column}) {
        return `Running Total${column ? ` of ${column}` : ''}`;
    },
});

const FORMULAS = {
    ADD,
    SUBTRACT,
    MULTIPLY,
    DIVIDE,
    RUNNING_TOTAL,
};

export default FORMULAS;
